import { render, staticRenderFns } from "./MulOrderDetailOamount.vue?vue&type=template&id=6386897c&scoped=true&"
import script from "./MulOrderDetailOamount.vue?vue&type=script&lang=ts&"
export * from "./MulOrderDetailOamount.vue?vue&type=script&lang=ts&"
import style0 from "./MulOrderDetailOamount.vue?vue&type=style&index=0&id=6386897c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6386897c",
  null
  
)

export default component.exports